import { createSlice } from '@reduxjs/toolkit';

const initialForumState = {
    solveTabForum: {},
    selectedForum: {},
    forumsData: [],
    forumComments: [
        {
            "id": 57,
            "offeringUserId": 2,
            "userId": 1,
            "likes": 0,
            "isLiked": false,
            "parentCommentId": null,
            "commentText": "hey",
            "isAssignment": false,
            "collapsed": false,
            "commentedOn": "2021-07-27T12:47:39.04",
            "userProfile": {
                "id": 1,
                "firstName": "Rupesh",
                "lastName": "Tarwade",
                "email": "rupesh@adeptusdev.onmicrosoft.com",
                "profileImage": ""
            },
            "replies": [
                {
                    "id": 58,
                    "offeringUserId": 2,
                    "userId": 1,
                    "likes": 1,
                    "isLiked": true,
                    "parentCommentId": 57,
                    "commentText": "test",
                    "isAssignment": false,
                    "collapsed": false,
                    "commentedOn": "2021-07-27T13:21:53.387",
                    "userProfile": {
                        "id": 1,
                        "firstName": "Rupesh",
                        "lastName": "Tarwade",
                        "email": "rupesh@adeptusdev.onmicrosoft.com",
                        "profileImage": ""
                    },
                    "replies": [],
                    "attachments": [],
                    "commentLikes": [
                        {
                            "commentId": 58,
                            "offeringUserId": 2
                        }
                    ]
                }
            ],
            "attachments": [],
            "commentLikes": []
        },
        {
            "id": 59,
            "offeringUserId": 2,
            "userId": 1,
            "likes": 1,
            "isLiked": true,
            "parentCommentId": null,
            "commentText": "this is second stage activity",
            "isAssignment": false,
            "collapsed": false,
            "commentedOn": "2021-07-27T13:41:16.497",
            "userProfile": {
                "id": 1,
                "firstName": "Rupesh",
                "lastName": "Tarwade",
                "email": "rupesh@adeptusdev.onmicrosoft.com",
                "profileImage": ""
            },
            "replies": [
                {
                    "id": 60,
                    "offeringUserId": 2,
                    "userId": 1,
                    "likes": 0,
                    "isLiked": false,
                    "parentCommentId": 59,
                    "commentText": "This is test",
                    "isAssignment": false,
                    "collapsed": false,
                    "commentedOn": "2021-07-28T07:04:14.58",
                    "userProfile": {
                        "id": 1,
                        "firstName": "Rupesh",
                        "lastName": "Tarwade",
                        "email": "rupesh@adeptusdev.onmicrosoft.com",
                        "profileImage": ""
                    },
                    "replies": [],
                    "attachments": [],
                    "commentLikes": []
                }
            ],
            "attachments": [],
            "commentLikes": [
                {
                    "commentId": 59,
                    "offeringUserId": 2
                }
            ]
        }
    ]
};

const forumSlice = createSlice({
    name: 'forum',
    initialState: initialForumState,
    reducers: {
        setTeamForum(state, action) {
            state.solveTabForum = action.payload;
        },
        setForumsData(state, action) {
            state.forumsData = action.payload;
        },
        setSelectedForum(state, action) {
            state.selectedForum = { ...action.payload };
        },
        setForumComments(state, action) {
            state.forumComments = [...action.payload.data.comments];
        }
    },
});

export default forumSlice;